import React, { useEffect, useState } from 'react';
import { ImageProps, Image } from 'react-native';

export type ImageWithFallbackProps = ImageProps & { fallback: ImageProps['source']; isSourceLoading?: boolean };

export const ImageWithFallback = ({
  source,
  fallback,
  isSourceLoading = false,
  ...imageProps
}: ImageWithFallbackProps) => {
  const [useFallback, setUseFallback] = useState<boolean>(false);

  useEffect(() => {
    // When source is loaded, check if it's valid
    if (!isSourceLoading) {
      if (!source) {
        setUseFallback(true);
      } else if (typeof source !== 'number') {
        // If source is remote but uri is missing, use fallback source
        if (Array.isArray(source)) {
          if (source.every((src) => !src.uri)) {
            setUseFallback(true);
          }
        } else if (!source.uri) {
          setUseFallback(true);
        }
      }
    }
  }, [isSourceLoading, source]);

  const imageSource = useFallback ? fallback : source;

  return (
    <Image
      {...imageProps}
      source={imageSource}
      onError={(e) => {
        if (!useFallback) {
          setUseFallback(true);
        }
        imageProps.onError?.(e);
      }}
    />
  );
};
